import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { Send } from "lucide-react";

export default function Campaigns() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/campaigns")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 lg:p-10">
      <div className="mb-8">
        <div className="label-eyebrow">Outreach</div>
        <h1 className="font-serif-display text-4xl text-[#0A1128] mt-2 tracking-tight">Campaigns</h1>
        <p className="text-slate-500 mt-2 text-sm">Every email dispatched from the desk.</p>
      </div>
      <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#F9FAFB] hover:bg-[#F9FAFB]">
              <TableHead className="text-[11px] uppercase tracking-widest text-slate-500">Sent</TableHead>
              <TableHead className="text-[11px] uppercase tracking-widest text-slate-500">Recipient</TableHead>
              <TableHead className="text-[11px] uppercase tracking-widest text-slate-500">Subject</TableHead>
              <TableHead className="text-[11px] uppercase tracking-widest text-slate-500">Sender</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell><Skeleton className="h-4 w-28" /></TableCell>
                  <TableCell><div className="space-y-1"><Skeleton className="h-4 w-32" /><Skeleton className="h-3 w-40" /></div></TableCell>
                  <TableCell><Skeleton className="h-4 w-48" /></TableCell>
                  <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                </TableRow>
              ))
            ) : items.length === 0 ? (
              <TableRow><TableCell colSpan={4} className="text-center py-10 text-slate-500 text-sm">
                <Send className="w-6 h-6 mx-auto mb-2 text-slate-300" />
                No campaigns yet. Draft your first AI email from any lead.
              </TableCell></TableRow>
            ) : (
              items.map((c) => (
                <TableRow key={c.campaign_id} data-testid={`campaign-${c.campaign_id}`}>
                  <TableCell className="text-xs text-slate-500">{new Date(c.created_at).toLocaleString()}</TableCell>
                  <TableCell><div className="text-sm text-[#0A1128]">{c.lead_name}</div><div className="text-xs text-slate-500">{c.lead_email}</div></TableCell>
                  <TableCell className="text-sm">{c.subject}</TableCell>
                  <TableCell className="text-sm text-slate-600">{c.sent_by}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
